/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { GridSettings } from '@app/shared/kendo/kendo-grid.component';
import { ProfileService } from '@app/profile/profile.service';
import { AuthenticationService, Setting } from '@app/core';

@Injectable()
export class KendoGridService {
  public constructor(private profileService: ProfileService, private authService: AuthenticationService) {}

  /**
   * Get grid setting
   * @param token Setting key
   */
  public get(token: string) {
    if (
      !this.authService.accessToken ||
      !this.authService.accessToken.profile ||
      !this.authService.accessToken.profile.settings
    ) {
      return false;
    }

    const setting = this.authService.accessToken.profile.settings.find((s: Setting) => {
      return s.name === token && s.collection === 'grid';
    });

    if (setting) {
      return setting.value;
    }

    return false;
  }

  /**
   * Set setting to API & reload user profile
   * @param token Setting key
   * @param gridConfig GridSettings
   */
  public set(token: string, gridConfig: GridSettings): void {
    this.profileService.setSetting(token, gridConfig, 'grid').subscribe(() => {
      this.authService.loadProfile().subscribe((res) => {
        return res;
      });
    });
  }
}
